export default __webpack_public_path__ + "static/media/GoldenStar.07eacb13.svg";